import { Component, OnInit } from '@angular/core';
import packageJson from 'package.json';

import { environment } from '@env';
import { DefaultModule, PrimeModule } from '@module';

import { PopupService } from 'pn-core-code';

import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'shared-version',
  standalone: true,
  imports: [DefaultModule, PrimeModule, DialogModule],
  template: `
    <a class="text-xs text-gray-400" (click)="onClickVersion()">
      version : {{ packageJson.version }}
    </a>
    <p-dialog
      header="Version"
      [modal]="true"
      [(visible)]="visible"
      position="top"
      key="version"
    >
      <div class="grid gap-2 grid-cols-1">
        <p>Version : {{packageJson.version}}</p>
        <p>CoreCode : {{packageJson.dependencies['pn-core-code']}}</p>
        <div class="flex justify-end gap-2">
          <p-button label="close" (click)="visible = false" />
        </div>
      </div>
    </p-dialog>
  `,
  styles: ``,
  providers: [PopupService],
})
export class SharedVersionComponent implements OnInit {
  packageJson = packageJson;

  visible: boolean = false;

  constructor(private popupService: PopupService) { }

  ngOnInit(): void {
    console.log('packageJson', packageJson);
  }

  onClickVersion() {
    if (environment.env !== 'PROD') {
      console.log('onClickVersion');
      this.visible = true;
    }
  }
}
